<template>
  <div class="wrap">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :inline="true"
      class="d-inline-block"
    >
      <el-form-item prop="from">
        <el-date-picker
          v-model="form.from"
          placeholder="Start"
          clearable
          type="datetime"
          :format="dateFormat"
          :value-format="formDateFormat"
        ></el-date-picker>
      </el-form-item>
      <el-form-item prop="till">
        <el-date-picker
          v-model="form.till"
          placeholder="End"
          clearable
          type="datetime"
          :format="dateFormat"
          :value-format="formDateFormat"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="build" class="d-inline-block align-top">Build</el-button>
    </el-form>
  </div>
</template>

<script>
import BaseParameters from '../parameters';

export default {
  extends: BaseParameters,

  data() {
    return {
      errors: {},
    };
  },

  computed: {
    /**
     * @return {String}
     */
    dateFormat() {
      return config('format.element.short.datetime');
    },

    /**
     * @return {String}
     */
    formDateFormat() {
      return config('format.datetime');
    },
  },

  methods: {
    /**
     * @return {object}
     */
    getForm() {
      return {
        from: null,
        till: null,
      };
    },
  }
}
</script>
